import { render } from "./BibliografiaSection.vue?vue&type=template&id=c4d39dbc&scoped=true"
import script from "./BibliografiaSection.vue?vue&type=script&lang=js"
export * from "./BibliografiaSection.vue?vue&type=script&lang=js"

import "./BibliografiaSection.vue?vue&type=style&index=0&id=c4d39dbc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c4d39dbc"]])

export default __exports__